export function objectMap(s, f) {
    return Object.keys(s).reduce((acc, p) => {
        acc[p] = f(p, s[p]);
        return acc;
    }, {});
}
//# sourceMappingURL=object-map.js.map